import { FC } from 'react';

import { Link } from 'react-router-dom';

import styles from './style.module.scss';

interface NameFieldProps {
  name: string;
  description: string;
  url: string;
}
const NameField: FC<NameFieldProps> = ({ name, description, url }) => {
  return (
    <Link to={url} className={styles.name} target={'_blank'}>
      <p title={`${name}\n\n${description}`}>{name}</p>
    </Link>
  );
};

export default NameField;
